import { registerComponent } from "react_mount"

// Public content pages use the content bundle instead of application, so both
// entrypoints import this shared registration module.
registerComponent(
  "podcast-listen-and-subscribe",
  () => import("containers/PodcastListenAndSubscribe"),
)
